import { render, staticRenderFns } from "./MesAffilies.vue?vue&type=template&id=45619db7"
import script from "./MesAffilies.vue?vue&type=script&lang=js"
export * from "./MesAffilies.vue?vue&type=script&lang=js"
import style0 from "./MesAffilies.vue?vue&type=style&index=0&id=45619db7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports